import { GlobalState } from "little-state-machine";

export const updateIsUserHistoryFilterDrawerOpen = (state: GlobalState, isUserHistoryFilterDrawerOpen: boolean) => ({
  ...state,
  isUserHistoryFilterDrawerOpen
});
